import { IEventAggregationService } from '@studyportals/event-aggregation-service-interface';
import { PortalType } from '@studyportals/domain-client';
import { InLineSearchApplication } from '@/application/in-line-search-application';
import { EventAggregationService } from '@/utils/EventAggregationService';
import { InlineSearchReadyEvent } from 'interfaces';
import { UserInputPlugin } from './store/plugins/UserInputPlugin';
import { DependencyCheckerPlugin } from './store/plugins/DependencyCheckerPlugin';
import { UserKeyBoardPlugin } from './store/plugins/UserKeyboardPlugin';
import { DataStorageSyncPlugin } from "@/store/plugins/DataStorageSyncPlugin";

declare global {
	interface Window {
		EventAggregationService: IEventAggregationService | undefined;
		PortalType: PortalType;
		rollbar?: typeof Rollbar;
		CookieFirst: {
			acceptAllCategories: () => void;
			withdrawConsent: () => void;
		};
		snowplow(source: string, payload: { terms: string[]; filters: object; totalResults: number }): void;
	}
}
class Main {
	constructor() {
		this.createApplication();
	}

	private createApplication(): void {
		new UserInputPlugin().initiate();
		new UserKeyBoardPlugin().initiate();
		new DataStorageSyncPlugin().initiate();
		new DependencyCheckerPlugin().initialize();

		const application = new InLineSearchApplication();

		EventAggregationService.instance?.publishTo(InlineSearchReadyEvent.EventType, new InlineSearchReadyEvent(application));
	}
}

const main = new Main();
export default main;